import { ISOCountryCode } from './ISOCountryCode';

export const COUNTRY_DIAL_CODES: Partial<Record<ISOCountryCode, string>> = {
  // +1 (North America & Caribbean)
  [ISOCountryCode.UnitedStatesAmerica]: '+1',
  [ISOCountryCode.UnitedStatesMinorOutlyingIslands]: '+1', // Uses US code
  [ISOCountryCode.Canada]: '+1',
  [ISOCountryCode.AntiguaAndBarbuda]: '+1',
  [ISOCountryCode.Anguilla]: '+1',
  [ISOCountryCode.AmericanSamoa]: '+1',
  [ISOCountryCode.Barbados]: '+1',
  [ISOCountryCode.Bermuda]: '+1',
  [ISOCountryCode.Bahamas]: '+1',
  [ISOCountryCode.Dominica]: '+1',
  [ISOCountryCode.DominicanRepublic]: '+1',
  [ISOCountryCode.Grenada]: '+1',
  [ISOCountryCode.Guam]: '+1',
  [ISOCountryCode.Jamaica]: '+1',
  [ISOCountryCode.SaintKittsNevis]: '+1',
  [ISOCountryCode.CaymanIslands]: '+1',
  [ISOCountryCode.SaintLucia]: '+1',
  [ISOCountryCode.NorthernMarianaIslands]: '+1',
  [ISOCountryCode.Montserrat]: '+1',
  [ISOCountryCode.PuertoRico]: '+1',
  [ISOCountryCode.TurksCaicosIslands]: '+1',
  [ISOCountryCode.TrinidadTobago]: '+1',
  [ISOCountryCode.SaintVincentGrenadines]: '+1',
  [ISOCountryCode.VirginIslandsBritish]: '+1',
  [ISOCountryCode.VirginIslandsUS]: '+1',

  // +7
  [ISOCountryCode.Russia]: '+7',
  [ISOCountryCode.Kazakhstan]: '+7',

  // +20-99
  [ISOCountryCode.Egypt]: '+20',
  [ISOCountryCode.SouthAfrica]: '+27',
  [ISOCountryCode.Greece]: '+30',
  [ISOCountryCode.Netherlands]: '+31',
  [ISOCountryCode.Belgium]: '+32',
  [ISOCountryCode.France]: '+33',
  [ISOCountryCode.Spain]: '+34',
  [ISOCountryCode.CanaryIslands]: '+34', // Uses Spain's code
  [ISOCountryCode.Hungary]: '+36',
  [ISOCountryCode.Italy]: '+39',
  [ISOCountryCode.Vatican]: '+39',
  [ISOCountryCode.Romania]: '+40',
  [ISOCountryCode.Switzerland]: '+41',
  [ISOCountryCode.Austria]: '+43',
  [ISOCountryCode.UnitedKingdom]: '+44',
  [ISOCountryCode.Guernsey]: '+44',
  [ISOCountryCode.IsleofMan]: '+44',
  [ISOCountryCode.Jersey]: '+44',
  [ISOCountryCode.Denmark]: '+45',
  [ISOCountryCode.Sweden]: '+46',
  [ISOCountryCode.Norway]: '+47',
  [ISOCountryCode.Poland]: '+48',
  [ISOCountryCode.Germany]: '+49',
  [ISOCountryCode.Peru]: '+51',
  [ISOCountryCode.Mexico]: '+52',
  [ISOCountryCode.Cuba]: '+53',
  [ISOCountryCode.Argentina]: '+54',
  [ISOCountryCode.Brazil]: '+55',
  [ISOCountryCode.Chile]: '+56',
  [ISOCountryCode.Colombia]: '+57',
  [ISOCountryCode.Venezuela]: '+58',
  [ISOCountryCode.Malaysia]: '+60',
  [ISOCountryCode.Australia]: '+61',
  [ISOCountryCode.CocosIslands]: '+61',
  [ISOCountryCode.ChristmasIsland]: '+61',
  [ISOCountryCode.Indonesia]: '+62',
  [ISOCountryCode.Philippines]: '+63',
  [ISOCountryCode.NewZealand]: '+64',
  [ISOCountryCode.PitcairnIslands]: '+64', // Uses New Zealand's code
  [ISOCountryCode.Singapore]: '+65',
  [ISOCountryCode.Thailand]: '+66',
  [ISOCountryCode.Japan]: '+81',
  [ISOCountryCode.SouthKorea]: '+82',
  [ISOCountryCode.Vietnam]: '+84',
  [ISOCountryCode.China]: '+86',
  [ISOCountryCode.Turkey]: '+90',
  [ISOCountryCode.India]: '+91',
  [ISOCountryCode.Pakistan]: '+92',
  [ISOCountryCode.Afghanistan]: '+93',
  [ISOCountryCode.SriLanka]: '+94',
  [ISOCountryCode.Myanmar]: '+95',
  [ISOCountryCode.Iran]: '+98',

  // +200-299
  [ISOCountryCode.Morocco]: '+212',
  [ISOCountryCode.WesternSahara]: '+212',
  [ISOCountryCode.Algeria]: '+213',
  [ISOCountryCode.Tunisia]: '+216',
  [ISOCountryCode.Libya]: '+218',
  [ISOCountryCode.Gambia]: '+220',
  [ISOCountryCode.Senegal]: '+221',
  [ISOCountryCode.Mauritania]: '+222',
  [ISOCountryCode.Mali]: '+223',
  [ISOCountryCode.Guinea]: '+224',
  [ISOCountryCode.IvoryCoast]: '+225',
  [ISOCountryCode.BurkinaFaso]: '+226',
  [ISOCountryCode.Niger]: '+227',
  [ISOCountryCode.Togo]: '+228',
  [ISOCountryCode.Benin]: '+229',
  [ISOCountryCode.Mauritius]: '+230',
  [ISOCountryCode.Liberia]: '+231',
  [ISOCountryCode.SierraLeone]: '+232',
  [ISOCountryCode.Ghana]: '+233',
  [ISOCountryCode.Nigeria]: '+234',
  [ISOCountryCode.Chad]: '+235',
  [ISOCountryCode.CentralAfricanRepublic]: '+236',
  [ISOCountryCode.Cameroon]: '+237',
  [ISOCountryCode.CapeVerde]: '+238',
  [ISOCountryCode.SaoTomePrincipe]: '+239',
  [ISOCountryCode.EquatorialGuinea]: '+240',
  [ISOCountryCode.Gabon]: '+241',
  [ISOCountryCode.RepublicCongo]: '+242',
  [ISOCountryCode.DemocraticRepublicCongo]: '+243',
  [ISOCountryCode.Angola]: '+244',
  [ISOCountryCode.GuineaBissau]: '+245',
  [ISOCountryCode.BritishIndianOceanTerritory]: '+246',
  [ISOCountryCode.Seychelles]: '+248',
  [ISOCountryCode.Sudan]: '+249',
  [ISOCountryCode.Rwanda]: '+250',
  [ISOCountryCode.Ethiopia]: '+251',
  [ISOCountryCode.Somalia]: '+252',
  [ISOCountryCode.Djibouti]: '+253',
  [ISOCountryCode.Kenya]: '+254',
  [ISOCountryCode.Tanzania]: '+255',
  [ISOCountryCode.Uganda]: '+256',
  [ISOCountryCode.Burundi]: '+257',
  [ISOCountryCode.Mozambique]: '+258',
  [ISOCountryCode.Zambia]: '+260',
  [ISOCountryCode.Madagascar]: '+261',
  [ISOCountryCode.Reunion]: '+262',
  [ISOCountryCode.Mayotte]: '+262',
  [ISOCountryCode.Zimbabwe]: '+263',
  [ISOCountryCode.Namibia]: '+264',
  [ISOCountryCode.Malawi]: '+265',
  [ISOCountryCode.Lesotho]: '+266',
  [ISOCountryCode.Botswana]: '+267',
  [ISOCountryCode.Eswatini]: '+268',
  [ISOCountryCode.Comoros]: '+269',
  [ISOCountryCode.SaintHelena]: '+290',
  [ISOCountryCode.Eritrea]: '+291',
  [ISOCountryCode.Aruba]: '+297',
  [ISOCountryCode.FaroeIslands]: '+298',
  [ISOCountryCode.Greenland]: '+299',

  // +350-399
  [ISOCountryCode.Gibraltar]: '+350',
  [ISOCountryCode.Portugal]: '+351',
  [ISOCountryCode.Luxembourg]: '+352',
  [ISOCountryCode.Ireland]: '+353',
  [ISOCountryCode.Iceland]: '+354',
  [ISOCountryCode.Albania]: '+355',
  [ISOCountryCode.Malta]: '+356',
  [ISOCountryCode.Cyprus]: '+357',
  [ISOCountryCode.Finland]: '+358',
  [ISOCountryCode.AlandIslands]: '+358',
  [ISOCountryCode.Bulgaria]: '+359',
  [ISOCountryCode.Lithuania]: '+370',
  [ISOCountryCode.Latvia]: '+371',
  [ISOCountryCode.Estonia]: '+372',
  [ISOCountryCode.Moldova]: '+373',
  [ISOCountryCode.Armenia]: '+374',
  [ISOCountryCode.Belarus]: '+375',
  [ISOCountryCode.Andorra]: '+376',
  [ISOCountryCode.Monaco]: '+377',
  [ISOCountryCode.SanMarino]: '+378',
  [ISOCountryCode.Ukraine]: '+380',
  [ISOCountryCode.Montenegro]: '+382',
  [ISOCountryCode.Croatia]: '+385',
  [ISOCountryCode.Slovenia]: '+386',
  [ISOCountryCode.BosniaHerzegovina]: '+387',
  [ISOCountryCode.NorthMacedonia]: '+389',

  // +420-423
  [ISOCountryCode.Czechia]: '+420',
  [ISOCountryCode.Slovakia]: '+421',
  [ISOCountryCode.Liechtenstein]: '+423',

  // +500-599
  [ISOCountryCode.FalklandIslands]: '+500',
  [ISOCountryCode.Belize]: '+501',
  [ISOCountryCode.Guatemala]: '+502',
  [ISOCountryCode.ElSalvador]: '+503',
  [ISOCountryCode.Honduras]: '+504',
  [ISOCountryCode.Nicaragua]: '+505',
  [ISOCountryCode.CostaRica]: '+506',
  [ISOCountryCode.Panama]: '+507',
  [ISOCountryCode.SaintPierreMiquelon]: '+508',
  [ISOCountryCode.Haiti]: '+509',
  [ISOCountryCode.Guadeloupe]: '+590',
  [ISOCountryCode.SaintBarthelemy]: '+590',
  [ISOCountryCode.Bolivia]: '+591',
  [ISOCountryCode.Guyana]: '+592',
  [ISOCountryCode.Ecuador]: '+593',
  [ISOCountryCode.FrenchGuiana]: '+594',
  [ISOCountryCode.Paraguay]: '+595',
  [ISOCountryCode.Martinique]: '+596',
  [ISOCountryCode.Suriname]: '+597',
  [ISOCountryCode.Uruguay]: '+598',
  [ISOCountryCode.Curacao]: '+599',
  [ISOCountryCode.BonaireSintEustatiusSaba]: '+599',

  // +670-699
  [ISOCountryCode.TimorLeste]: '+670',
  [ISOCountryCode.NorfolkIsland]: '+672',
  [ISOCountryCode.BruneiDarussalam]: '+673',
  [ISOCountryCode.Nauru]: '+674',
  [ISOCountryCode.PapuaNewGuinea]: '+675',
  [ISOCountryCode.Tonga]: '+676',
  [ISOCountryCode.SolomonIslands]: '+677',
  [ISOCountryCode.Vanuatu]: '+678',
  [ISOCountryCode.Fiji]: '+679',
  [ISOCountryCode.Palau]: '+680',
  [ISOCountryCode.WallisFutuna]: '+681',
  [ISOCountryCode.CookIslands]: '+682',
  [ISOCountryCode.Niue]: '+683',
  [ISOCountryCode.Samoa]: '+685',
  [ISOCountryCode.Kiribati]: '+686',
  [ISOCountryCode.NewCaledonia]: '+687',
  [ISOCountryCode.Tuvalu]: '+688',
  [ISOCountryCode.FrenchPolynesia]: '+689',
  [ISOCountryCode.Tokelau]: '+690',
  [ISOCountryCode.Micronesia]: '+691',
  [ISOCountryCode.MarshallIslands]: '+692',

  // +850-899
  [ISOCountryCode.NorthKorea]: '+850',
  [ISOCountryCode.HongKong]: '+852',
  [ISOCountryCode.Macao]: '+853',
  [ISOCountryCode.Cambodia]: '+855',
  [ISOCountryCode.Lao]: '+856',
  [ISOCountryCode.Bangladesh]: '+880',
  [ISOCountryCode.Taiwan]: '+886',

  // +960-999
  [ISOCountryCode.Maldives]: '+960',
  [ISOCountryCode.Lebanon]: '+961',
  [ISOCountryCode.Jordan]: '+962',
  [ISOCountryCode.SyrianArabRepublic]: '+963',
  [ISOCountryCode.Iraq]: '+964',
  [ISOCountryCode.Kuwait]: '+965',
  [ISOCountryCode.SaudiArabia]: '+966',
  [ISOCountryCode.Yemen]: '+967',
  [ISOCountryCode.Oman]: '+968',
  [ISOCountryCode.Palestine]: '+970',
  [ISOCountryCode.UnitedArabEmirates]: '+971',
  [ISOCountryCode.Israel]: '+972',
  [ISOCountryCode.Bahrain]: '+973',
  [ISOCountryCode.Qatar]: '+974',
  [ISOCountryCode.Bhutan]: '+975',
  [ISOCountryCode.Mongolia]: '+976',
  [ISOCountryCode.Nepal]: '+977',
  [ISOCountryCode.Tajikistan]: '+992',
  [ISOCountryCode.Turkmenistan]: '+993',
  [ISOCountryCode.Azerbaijan]: '+994',
  [ISOCountryCode.Georgia]: '+995',
  [ISOCountryCode.Kyrgyzstan]: '+996',
  [ISOCountryCode.Uzbekistan]: '+998',
};
